import * as React from 'react';
import { inject, observer } from 'mobx-react';
import './sessionListPane.module.scss';
import { CalendarView } from '../../molecules/calendar/CalendarView';
import { DateGroup } from '../../molecules/reservable/DateGroup';
import { ScheduleListItem } from '../../molecules/reservable/ScheduleListItem';
import { groupByDate, ReservableType } from '../../../../commonv3/types/reservable';
import { BackButton } from '../../../../commonv3/components/atoms/buttons/BackButton';
import moment from 'moment-timezone';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { V3Routes } from '../../../routes';
import { isFullSession, SessionType } from '../../../types/sessions';
import { getOnlineSelector } from '../../molecules/forms/LocationSelector';
import { Warning } from '../../atoms/membership_plans/Warning';
import { HomePageState } from '../../../containers/home/states/HomePageState';

type Props = {
    homeState: HomePageState;
};

@inject('homeState')
@observer
export class CareerCoachingSessionListPane extends React.Component<Props> {
    async componentDidMount() {
        const { sessionList } = this.props.homeState;
        const sessionType = SessionType.MULTICREATOR_CAREER_COACHING;
        sessionList.setSessionType(sessionType);
        sessionList.setSelectedLocationSelectors([getOnlineSelector()]);
        await sessionList.reloadSessions();
    }

    render() {
        const { sessionList, reservationList } = this.props.homeState;
        const { sessionsOfType, filteredSessions, selectedDate, setSelectedDate, setSelectedMonth } = sessionList;
        const groups = groupByDate(filteredSessions, (r) => r.starts_at);
        const { availableTokens } = GlobalStatesV3.currentUser;

        return (
            <div id="session-pane" styleName="pane">
                {GlobalStatesV3.viewport.isMobile && <BackButton />}
                <div styleName="pane-header">
                    <div styleName="pane-title">1on1キャリアコーチングの予約</div>
                    <div styleName="pane-header-border" />
                </div>
                <div styleName="views">
                    <div styleName="calendar-wrapper">
                        <CalendarView
                            startDate={moment().date(1)}
                            endDate={moment()
                                .add(6, 'month')
                                .date(1)}
                            selectedDate={selectedDate}
                            clickables={sessionsOfType.map((r) => r.starts_at)}
                            onClick={setSelectedDate}
                            onMonthChange={setSelectedMonth}
                        />
                    </div>
                    <div styleName="schedule-list-wrapper">
                        <Warning>
                            予約いただいた1on1キャリアコーチングの日程は、変更・キャンセルができないのでご了承ください
                        </Warning>
                        <div id="schedule-list-body" styleName="schedule-list-body">
                            {groups.map((group) => (
                                <DateGroup key={group.date} date={group.date}>
                                    {group.entries.map((entry) => {
                                        const reserved = reservationList.isReserved(ReservableType.SESSION, entry.id);
                                        const isReservable = availableTokens.isAffordable(
                                            entry.required_token_type,
                                            entry.required_token_amount,
                                            entry.starts_at
                                        );
                                        return (
                                            <ScheduleListItem
                                                key={entry.id}
                                                title={entry.template_name}
                                                reservable={entry}
                                                actionItem={
                                                    <div styleName="actions">
                                                        <Button
                                                            id="session-reserve-button"
                                                            styleName="button"
                                                            type="primary"
                                                            disabled={!isReservable || reserved || isFullSession(entry)}
                                                            size="xs"
                                                            onClick={() =>
                                                                GlobalStatesV3.routing.push(
                                                                    V3Routes.sessionReservation(entry.id)
                                                                )
                                                            }
                                                        >
                                                            {reserved
                                                                ? '予約済'
                                                                : isFullSession(entry)
                                                                    ? '満席'
                                                                    : '予約する'}
                                                        </Button>
                                                    </div>
                                                }
                                            />
                                        );
                                    })}
                                </DateGroup>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
